import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TooltipModule } from 'primeng/tooltip';

import { CommonBasicModule } from '../Common/Basic/basic.module';
import { CommonFormsModule } from '../Common/Forms/forms.module';
import { DashboardSharedModule } from '../Common/Dashboard/dashboard-shared.module';
import { PageBuilderModule } from '../Common/PageBuilder/page-builder.module';
import { LayoutModule } from '../Common/Layout/layout.module';
import { LocalizationModule } from '../Core/Localization/localization.module';
import { MiscModule } from '../Common/Misc/misc.module';
import { LandingPageRoutingModule } from './landingpage-routing.module';
import { LandingPageComponent } from './components/LandingPage/landingPage.component';
import { LandingPageHelpCenterComponent } from './components/HelpCenter/landing-page-help-center.component';
import { LandingPageFeedReaderComponent } from './components/FeedReader/landing-page-feed-reader.component';
import { ProductFeatureItemComponent } from './components/ProductFeatureItem/product-feature-item.component';
import { ProductFeaturesComponent } from './components/ProductFeatures/product-features.component';
import { RecentActivitiesComponent } from './components/RecentActivities/recent-activities.component';
import { CarouselModule } from 'primeng/carousel';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        CommonBasicModule,
        LandingPageRoutingModule,
        DashboardSharedModule,
        CommonFormsModule,
        LayoutModule,
        PageBuilderModule,
        LocalizationModule,
        TooltipModule,
        MiscModule,
        CarouselModule,
        FormsModule
    ],
    declarations: [
        LandingPageComponent,
        LandingPageHelpCenterComponent,
        LandingPageFeedReaderComponent,
        ProductFeaturesComponent,
        ProductFeatureItemComponent,
        RecentActivitiesComponent
    ]
})
export class LandingPageModule {}
